<template>
  <div class="page-payment" v-loading.fullscreen.lock="fullLoading">
    <step-breadcrumb :stepIndex="3"/>
    <div class="block">
      <div class="block-left" v-if="detail">
        <p>{{ $t('Booking Summary') }}</p>
        <div class="hotel-info">
          <img alt="hotel img" :src="detail.hotel_img">
          <div>
            <span>{{ $t('Hotel Selection') }}{{ $t(':') }}</span>
            <p>{{ detail.check_hotel_info.hotel }}</p>
          </div>
        </div>
        <ul class="room-list">
          <li class="room" v-for="(room,roomIndex) of detail.check_data.rooms" :key="roomIndex">
            <div class="room-info">
              <p class="room-title">{{ $t('Room {s} Reservation Details', {s: roomIndex + 1}) }}{{ $t(':') }}</p>
              <table>
                <tr>
                  <td>{{ $t('Room Type') }}{{ $t(':') }}</td>
                  <td>{{ room.room_group_name }}<br/>{{ room.roomtype_name }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Rate') }}{{ $t(':') }}</td>
                  <td> {{ room.rate_name }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Check-In Date') }}{{ $t(':') }}</td>
                  <td>{{ detail.check_hotel_info.check_in_date_format }}</td>
                </tr>
                <tr>
                  <td>{{ $t('Check-Out Date') }}{{ $t(':') }}</td>
                  <td>{{ detail.check_hotel_info.check_out_date_format }}</td>
                </tr>
                <tr>
                  <td>{{ $t('No. of Nights') }}{{ $t(':') }}</td>
                  <td>{{ detail.check_hotel_info.number_of_nights }}</td>
                </tr>
                <tr>
                  <td>{{ $t('No. of Guests') }}{{ $t(':') }}</td>
                  <td>{{ detail.check_hotel_info.adults }} {{ $t('Adults') }}{{ $t(',') }}
                    {{ detail.check_hotel_info.children }}
                    {{ $t('Children') }}
                  </td>
                </tr>
                <tr v-for="(pack,packageIndex) of room.package" :key="packageIndex">
                  <td>{{ pack.package_name }}{{ $t(':') }}</td>
                  <td>{{ pack.quantity }} {{ pack.unit }}</td>
                </tr>

              </table>
              <el-collapse value="0">
                <el-collapse-item class="charges" name="1">
                  <p class="title" slot="title">{{ $t('Charges') }}{{ $t(':') }}
                    <span>{{ $t('Sub Total') }}{{ $t(':') }} {{ room.sub_total | formatMoney($t(currency)) }}</span></p>
                  <table>
                    <tr v-for="(day,key,dayIndex) of room.price" :key="dayIndex">
                      <td>{{ key }}{{ $t(':') }}</td>
                      <td>{{ day.price | formatMoney($t(currency)) }}</td>
                    </tr>
                    <tr>
                      <td class="nbsp"></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>{{ $t('Total Room Charges') }}{{ $t(':') }}</td>
                      <td>{{ room.room_total_price | formatMoney($t(currency)) }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Additional Options') }}{{ $t(':') }}</td>
                      <td>{{ room.additional_options | formatMoney($t(currency)) }}</td>
                    </tr>
                  </table>
                  <p class="subtitle">{{ $t('Sub Total') }}{{ $t(':') }} {{
                      room.sub_total | formatMoney($t(currency))
                    }}</p>
                </el-collapse-item>
              </el-collapse>
            </div>

            <span>
              <el-button
                class="cancellation"
                @click="showPolicy(room.cancellation_policy)">
                {{ $t('Cancellation Policy') }} &#x00bb;
              </el-button>
            </span>

            <el-button v-if="rooms_info.length!==1" @click="remove(roomIndex)">
              <i class="el-icon-delete"/>
            </el-button>
          </li>
        </ul>
        <div class="total">
          <table>
            <tr>
              <td>{{ $t('Room Total Charges') }}{{ $t(':') }}</td>
              <td>{{ detail.check_data.room_total_charges | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Service Charges') }}{{ $t(':') }}</td>
              <td>{{ detail.check_data.service_amount | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Government Tax') }}{{ $t(':') }}</td>
              <td>{{ detail.check_data.tax_amount | formatMoney($t(currency)) }}</td>
            </tr>
            <tr class="grand-total">
              <td>{{ $t('Grand Total') }}{{ $t(':') }}</td>
              <td>{{ detail.check_data.grand_total | formatMoney($t(currency)) }}</td>
            </tr>

            <tr class="on-total">
              <td>{{ $t('Online Payment') }}{{ $t(':') }}</td>
              <td>{{ detail.check_data.online_payment | formatMoney($t(currency)) }}</td>
            </tr>
            <tr class="off-total">
              <td>{{ $t('Outstanding Balance') }}{{ $t(':') }}</td>
              <td>{{ detail.check_data.offline_payment | formatMoney($t(currency)) }}</td>
            </tr>

          </table>
        </div>
      </div>
      <div class="block-right" v-if="formReady">
        <p class="block-title">
          {{ $t('Guest Information') }}
        </p>
        <el-form
          :model="form"
          :rules="rules"
          ref="informationForm">
          <el-collapse class="room-list" :value='detail.check_data.rooms.map((v,i)=>i)'>
            <el-collapse-item
              class="room"
              v-for="(room,roomIndex) of detail.check_data.rooms"
              :key="roomIndex"
              :name="roomIndex">
              <div slot="title" class="room-title">
                <span>{{ $t('Information for Room {s}', {s: roomIndex + 1}) }}</span>
                <div class="same-as" v-if="roomIndex!==0" @click.stop>
                  <el-checkbox @change="checked=>sameAs(roomIndex,checked,room.rate_code)">
                    <span class="mob">{{ $t('Same as Room 1') }}</span> <span
                    class="pc">{{ $t('Same Information as Room 1') }}</span>
                  </el-checkbox>
                </div>
              </div>
              <div class="form-content">
                <div class="form-tips">
                  {{ $t('Please complete the following information') }}
                </div>

                <el-form-item
                  :label="$t('Title')+$t(':')"
                  :prop="'rooms[' + roomIndex + '].Title'"
                  :rules="{ required: true, message: $t('Please choose your title')}">
                  <el-select
                    v-model="form.rooms[roomIndex].Title"
                    :placeholder="'-' + $t('Please Select') + '-'">
                    <el-option
                      v-for="(title,index) of titles"
                      :label="title.name"
                      :value='`{"name":"${title.name}","code":"${title.code}"}`'
                      :key="index"/>
                  </el-select>
                </el-form-item>


                <el-form-item
                  :label="$t('Last Name')+$t(':')"
                  :prop="'rooms[' + roomIndex + '].Lastname'"
                  :rules="[{ required: true, message: $t('Please insert guest\'s last name')},
                  { required: true,pattern:/^[ A-Za-z]+$/ ,message: $t('Last name must be letter')}
                  ]">
                  <el-input
                    v-model="form.rooms[roomIndex].Lastname"
                    :readonly="form.rooms[roomIndex].rate_code == employeeRate[hotel_code]"
                    :placeholder="$t('Surname on Passport / ID')
                  "/>
                </el-form-item>


                <el-form-item
                  :label="$t('First Name')+$t(':')"
                  :prop="'rooms[' + roomIndex + '].Firstname'"
                  :rules="[{ required: true, message: $t('Please insert guest\'s first name')},
                  { required: true,pattern:/^[ A-Za-z]+$/ ,message: $t('First name must be letter')}]">
                  <el-input
                    v-model="form.rooms[roomIndex].Firstname"
                    :readonly="form.rooms[roomIndex].rate_code == employeeRate[hotel_code]"
                    :placeholder="$t('Given Name on Passport / ID')"
                  />
                </el-form-item>

                <el-form-item
                  :label="$t('Place of Residence')+$t(':')"
                  :prop="'rooms[' + roomIndex + '].CountryCode'"
                  :rules="{ required: true, message: $t('Please choose your place of residence')}">
                  <el-select
                    @change="x=>autoArea(x,roomIndex)"
                    v-model="form.rooms[roomIndex].CountryCode"
                    filterable
                    :placeholder="'-' + $t('Please Select') + '-'">
                    <el-option
                      class="select-residence"
                      v-for="(country,index) of countries"
                      :label="country[lang]||country.name"
                      :value='`{"name":"${country.name}","code":"${country.code}","area":"${country.phone}"}`'
                      :key="index"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item class="phone-group" :label="$t('Phone Number')+$t(':')" required>
                  <div class="group-col phone-area">
                    <el-form-item :prop="'rooms[' + roomIndex + '].area'" :rules="[{ required: true, message: $t('required')},
                                  {type: 'number',message:$t('Must be number')}]">
                      <el-input v-model.number="form.rooms[roomIndex].area" maxlength="8"/>
                    </el-form-item>
                  </div>
                  <div class="group-col line">-</div>
                  <div class="group-col phone-number">
                    <el-form-item :prop="'rooms[' + roomIndex + '].Phone'"
                                  :rules="[{ required: true, message: $t('Please insert phone number')},
                                  {type: 'number',message:$t('Phone number must be number')},
                                  {pattern:/^\d{7,15}$/,message:$t('Between 7 and 15 characters'),trigger: 'blur'}]">
                      <el-input v-model.number="form.rooms[roomIndex].Phone" maxlength="15"/>
                    </el-form-item>
                  </div>
                </el-form-item>

                <el-form-item
                  :label="$t('Email Address')+$t(':')"
                  class="email-notification"
                  :prop="'rooms[' + roomIndex + '].Email'"
                  :rules="[{ type: 'email',message:$t('Please insert correct email format') ,trigger: 'blur' },
                  { required:true,message: $t('Please insert correct email format')}]">
                  <el-input v-model="form.rooms[roomIndex].Email"/>
                </el-form-item>

                <el-form-item
                  :label="$t('Arrival Time')+$t(':')"
                  class="arrival-time"
                  :prop="'rooms[' + roomIndex + '].ArrivalTime'">
                  <el-time-select
                    :placeholder="'-' + $t('Time of Arrival') + '-'"
                    v-model="form.rooms[roomIndex].ArrivalTime"
                    :picker-options="{
                      start:'00:00',
                      end:'23:00',
                      step: '00:60'}"/>
                </el-form-item>


                <el-form-item
                  :label="$t('Special Request')+$t(':')"
                  class="special-request"
                  prop="Special_codes">
                  <el-checkbox-group
                    class="el-checkbox-group"
                    v-model="form.rooms[roomIndex].Special_codes">
                    <el-checkbox
                      v-for="(special,specialIndex) of specials"
                      :label="special.code"
                      :key="specialIndex"
                      name="Special_codes"
                    >
                      {{ special.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>

                <el-form-item :label="$t('Additional Info')+$t(':')">
                  <el-input type="textarea" v-model="form.rooms[roomIndex].Comments" maxlength="255"
                            show-word-limit></el-input>
                </el-form-item>


              </div>
            </el-collapse-item>
          </el-collapse>
          <p class="block-title">
            {{ $t('Payment Information') }}
          </p>

          <div class="payment-content">

            <p v-if="payTips.pay_type==='guarantee-pay'" :class="payTips.pay_type"
               v-html="$t(`${payTips.pay_type} {s,s2}`, {s: payTips.pay_price,s2:formatMoney(detail.check_data.offline_payment,$t(currency))})"/>
            <p v-else :class="payTips.pay_type" v-html="$t(`${payTips.pay_type} {s}`, {s: payTips.pay_price})"/>

            <el-form-item prop="pay_type" :rules="{ required:true,message: $t('Please choose your payment method')}">
              <el-radio-group v-model="form.pay_type">
                <el-radio class="full-fill" label="ICBCOnlinePosOrder" :disabled="!detail.check_data.online_payment">
                  <div class="pay-content">
                    <span>{{ $t('Credit Card') }}</span>
                    <div class="icon-content">
                      <img alt="Credit Card" src="@/assets/images/payment/visa.png">
                      <img alt="Credit Card" src="@/assets/images/payment/master.png">
                      <img alt="Credit Card" src="@/assets/images/payment/paypal.png" v-if="0">
                      <img alt="Credit Card" src="@/assets/images/payment/UnionPay.png">

                      <img alt="Credit Card" src="@/assets/images/payment/AE.png" v-if="0">
                      <img alt="Credit Card" src="@/assets/images/payment/jcb.png" v-if="0">
                    </div>
                  </div>
                </el-radio>
                <el-radio v-if="0" label="ICBCOnlinePosOrder" :disabled="!detail.check_data.online_payment">
                  <div class="pay-content">
                    <span>{{ $t('Paypal') }}</span>
                    <div class="icon-content">
                      <img alt="Credit Card" src="@/assets/images/payment/paypal.png">
                    </div>
                  </div>
                </el-radio>
                <el-radio v-if="0" label="ICBCOnlinePosOrder" :disabled="!detail.check_data.online_payment">
                  <div class="pay-content">
                    <span>{{ $t('Union Pay') }}</span>
                    <div class="icon-content">
                      <img alt="Credit Card" src="@/assets/images/payment/UnionPay.png">
                    </div>
                  </div>
                </el-radio>
                <!-- <el-radio :label="isMobile?'AlipayWAP':'AlipayPC'" :disabled="!detail.check_data.online_payment">
                  <div class="pay-content">
                    <span>{{ $t('Alipay') }}</span>
                    <div class="icon-content">
                      <img alt="Credit Card" src="@/assets/images/payment/Alipay.png">
                    </div>
                  </div>
                </el-radio>
                <el-radio :label="isMobile?'WechatPayWAP':'WechatPayPC'" :disabled="!detail.check_data.online_payment">
                  <div class="pay-content">
                    <span>{{ $t('WeChat Pay') }}</span>
                    <div class="icon-content">
                      <img alt="Credit Card" src="@/assets/images/payment/wechat-pay.png">
                    </div>
                  </div>
                </el-radio> -->
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="terms">
            <el-form-item :label="$t('Terms & Conditions')+$t(':')" prop="terms">
              <el-checkbox-group v-model="form.terms">
                <el-checkbox :label="1">
                  {{ $t('Accepting') }}
                  <router-link :to="{name:'TermsOfUse', query:{skin: skin}}" target="_blank">{{ $t('Terms of Use') }}</router-link>
                  {{ $t('and') }}
                  <router-link :to="{name:'PrivacyPolicy', query:{skin: skin}}" target="_blank">{{ $t('Privacy Policy') }}</router-link>
                </el-checkbox>
                <el-checkbox :label="2">
                  {{ $t('Allow contact information to be used for marketing') }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>

          <div class="button-set">
            <el-button type="primary" @click="submit">{{ $t('SUBMIT') }}</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <silk-popup :show="policy" @popup-close="policy=''" class="policy-popup">
      <span class="popup-title">{{ $t('Cancellation Policy') }}</span>
      <div class="policy-content cms-style" v-html="policy"></div>
    </silk-popup>
  </div>

</template>

<script>
import StepBreadcrumb from '@/components/StepBreadcrumb.vue'
import {mapState} from 'vuex'
import util from '@/util'

const countries = require('../assets/files/countries.json')

export default {
  data: function () {

    const terms = (rule, value, callback) => {
      if (value.length !== 2) {
        return callback(new Error(this.$t('Please check the Terms of Use')));
      } else {
        callback()
      }
    };

    return {
      detail: '',
      countries,
      titles: [],
      specials: [],
      form: {
        terms: [2],
        rooms: [],
        pay_type: ''
      },
      account: {},
      formTemp: {
        CountryCode: '',
        Title: '',
        Firstname: '',
        Lastname: '',
        Phone: '',
        area: '',
        Email: '',
        Email_confirm: '1',
        Comments: '',
        Special_codes: [],
        ArrivalTime: '',
        rate_code: '',
      },
      rules: {
        terms: [
          {validator: terms}
        ]
      },
      formReady: false,
      fullLoading: true,
      policy: "",
      timer: "",
      hotel_code: '',
    }
  },
  methods: {
    /*
    * @method { Function } getInfos 获取信息通用方法
    * @param { String } url 请求地址
    * @param { String } dataKey 本地属性名
    * @param { String } resKey 远程属性名
    * @param { Object } data 请求配置信息
    * */
    getInfos(url, dataKey, resKey, data = {}) {
      return this.axios.get(url, data)
        .then((res) => {
            if (res.code === 200) {
              this[dataKey] = res.data[resKey]
            }
          }
        )
    },
    getRoomInfo() {
      this.axios.get('/api/employee/room/checkout', {
        params: Object.assign({}, this.$route.query)
      }).then(
        (res) => {
          if (res.code === 200) {
            this.detail = res.data
            if (!this.detail.check_data.online_payment) {
              this.form.pay_type = 'None'
            }
            if (!this.form.rooms.length) {
              this.detail.check_data.rooms.forEach(( room ) => {
                this.form.rooms.push(Object.assign({}, this.formTemp, {rate_code: room.rate_code}))
              })
            }
            this.getInfos('/api/employee/info/specials', 'specials', 'specials', {
              params: {'hotel-code': this.detail.check_hotel_info.hotel_code}
            }).then(() => {
              this.$nextTick(() => {
                this.formReady = true
                this.fullLoading = false
              })
            })
          } else {
            this.$alert(res.msg, {
                  confirmButtonText: this.$t('CLOSE'),
                  center: true,
                  callback: () => {
                    this.$router.push({name: 'Home', query:{skin: this.skinCode}})
                  }
            }).then(() => {
                  this.$router.push({name: 'Home', query:{skin: this.skinCode}})
            });
          }
        }
      )
    },
    getUserInfo() {
      this.axios.get('/api/employee/auth/info').then((res) => {
        if (res.code === 200) {
          localStorage.username = res.data.first_name+' '+ res.data.last_name
          localStorage.employee_quota = res.data.employee_quota
          localStorage.employee_rate = JSON.stringify(res.data.employee_rate)
          localStorage.fnf_quota = res.data.fnf_quota
          localStorage.fnf_rate = JSON.stringify(res.data.fnf_rate)
          this.$store.commit('stateChange', {k: 'username', v: res.data.first_name+' '+ res.data.last_name})
          this.$store.commit('stateChange', {k: 'employeeQuota', v: res.data.employee_quota})
          this.$store.commit('stateChange', {k: 'employeeRate', v: res.data.employee_rate})
          this.$store.commit('stateChange', {k: 'fnfQuota', v: res.data.fnf_quota})
          this.$store.commit('stateChange', {k: 'fnfQuota', v: res.data.fnf_rate})
          this.account = res.data
        }
      })
    },
    autoArea(code, index) {
      this.form.rooms[index].area = +JSON.parse(code).area
    },
    remove(index) {
      const query = this.$route.query;
      let submit = query.submit.split(',')
      submit.splice(index, 1)
      submit = submit.join(',')
      let obj = Object.assign({}, this.form)
      obj.rooms.splice(index, 1)
      localStorage.form = JSON.stringify(obj)
      this.$router.replace({
        'name': 'Payment', query: Object.assign({}, query, {submit})
      })
      let selects = JSON.parse(localStorage.getItem('selects'))
      selects.splice(index, 1)
      localStorage.setItem('selects', JSON.stringify(selects))
      localStorage.setItem('room', Number(localStorage.getItem('room')) - 1)
      this.$route.query.rooms -= 1
    },
    sameAs(roomIndex, checked, code,  target = 0) {
      if(code == this.employeeRate[this.hotel_code]) {
        let empAccount = {
          Firstname: this.account.first_name,
          Lastname: this.account.last_name,
          Phone: +this.account.phone,
          rate_code: this.employeeRate[this.hotel_code]
        }
        if(checked) {
          this.$set(this.form.rooms, roomIndex, Object.assign({}, this.form.rooms[target], empAccount))
        } else {
          this.$set(this.form.rooms, roomIndex, Object.assign({}, this.formTemp, empAccount))
        }
      } else {
        if(checked) {
          this.$set(this.form.rooms, roomIndex, Object.assign({}, this.form.rooms[target], {rate_code: code}))
        } else {
          this.$set(this.form.rooms, roomIndex, Object.assign({}, this.formTemp))
        }
      }
    },
    submit() {
      this.$refs.informationForm.validate((valid) => {
        if (valid) {
          localStorage.form = JSON.stringify(this.form)
          this.timer = setTimeout(() => {
            this.$confirm(this.$t('Request timeout, do you want to refresh the page?'), this.$t('timeout'), {
              confirmButtonText: this.$t('refresh'),
              cancelButtonText: this.$t('waiting'),
              type: 'warning'
            }).then(() => {
              // window.location.reload()
            }).catch(() => {
            });
          }, 30000)
          this.checkRoom()
        } else {
          return false;
        }
      });
    },
    //校验房间是否可以被预定
    checkRoom() {
      this.fullLoading = true
      this.axios.post('/api/employee/order/check-room', {rooms: this.checkRoomData})
        .then((res) => {
          if (res.code === 200) {
            this.pay()
          } else {
            this.fullLoading = false
            this.$alert(this.$t('room unavailable content'), this.$t('room unavailable title'), {
              confirmButtonText: this.$t('EDIT BOOKING'),
              center: true,
            }).then(() => {
              this.$router.push({name: 'SelectRoom', query: Object.assign({}, this.$route.query)})
            })
            clearTimeout(this.timer)
          }
        }).finally(() => {
      })
    },
    //发起支付请求
    pay() {
      this.fullLoading = true
      this.axios.post('/api/employee/pay', this.payData)
        .then((res) => {
          if (res.code === 200) {
            window.location.href = res.data.redirectUrl
            // 支付成功后删除选定房间
            localStorage.removeItem('selects')
            // window.open(res.data.redirectUrl)
            // this.$router.push({'path': `/Confirmation?merchantOrderId=${res.data.merchantOrderId}`})
          } else {
            this.$alert(res.msg, {
              confirmButtonText: this.$t('CLOSE'),
              center: true,
            }).then(() => {
              this.$router.push({name: 'SelectRoom', query: Object.assign({}, this.$route.query)})
            })
          }
        }).finally(() => {
        clearTimeout(this.timer)
        this.fullLoading = false
      })

    },
    gaEvent(eventData) {
      const info = eventData.check_hotel_info
      let rooms = []
      eventData.check_data.rooms.forEach((room) => {
        Object.entries(room.price).forEach((x) => {
          //room
          let obj = {
            name: room.room_type_name_en + '+' + room.rate_name_en,
            sku: room.roomtype_code + '+' + room.rate_code,
            price: 0,
            quantity: 1,
            tax: 0,
            serviceFee: 0,
            hotel: info.hotel_code,
            date: '',
          }
          obj.date = x[1].date
          obj.price = x[1].price
          obj.tax = x[1].tax_amount
          obj.serviceFee = x[1].service_amount
          rooms.push(obj)
        })
        //package
        // room.package.forEach((p) => {
        //   let packageObj = {
        //     name: p.package_name,
        //     sku: p.package_code,
        //     price: p.total_price,
        //     quantity: p.total_quantity,
        //     tax: 0,
        //     hotel: info.hotel_code,
        //     date: '',
        //   }
        //   rooms.push(packageObj)
        // })
      })

      let gaData = {
        currentTimeMacau: localStorage.date || '',
        currentTimeLocal: util.dateStr(new Date(), true),
        currentStep: 3,
        cookieId: '',
        skinCode: this.gaData.skinCode,
        memberLoggedIn: false,
        //step2 data
        checkInDate: info.check_in_date,
        checkOutDate: info.check_out_date,
        selectedHotel: info.hotel_code,
        numberTotalRooms: rooms.length,
        numberTotalAdults: +info.adults,
        numberTotalChild: +info.children,
        numberTotalNights: info.number_of_nights,
        //step3 data
        transactionProducts: rooms
      }

      window.dataLayer.push(gaData)
      window._mtm.push({"event": "booking data ready"})
    },
    showPolicy(html) {
      let police = ''
      Object.keys(html).forEach((key) => police += html[key])
      this.policy = police
    }
  },
  created() {
    window.scrollTo({
      top,
      behavior: "smooth"
    });
    //this.$root.$children[0].gaInit()
    this.getRoomInfo()
    this.getUserInfo()
    this.getInfos('/api/employee/info/titles', 'titles', 'titles')
    // this.getInfos('/api/employee/info/countries', 'countries', 'country')
    const type = window.performance.navigation.type
    //0 : TYPE_NAVIGATE (用户通过常规导航方式访问页面，比如点一个链接，或者一般的get方式)
    //1 : TYPE_RELOAD (用户通过刷新，包括JS调用刷新接口等方式访问页面)
    //2 : TYPE_BACK_FORWARD (用户通过后退按钮访问本页面)
    if (type && typeof localStorage.form !== "undefined") {
      this.form = JSON.parse(localStorage.form)
    } else {
      localStorage.removeItem("form");
    }
    if(this.$route.query.hotel_code) {
      this.hotel_code = this.$route.query.hotel_code
      this.$store.commit('stateChange', {k: 'hotel_code', v: this.$route.query.hotel_code})
    } else {
      this.hotel_code = this.$store.state.hotel_code
    }
  },
  components: {
    StepBreadcrumb
  },
  computed: {
    ...mapState(
      ['SearchParams', 'currency', 'dataLayerReady', 'gaData']
    ),
    hotel_info() {
      return this.detail.check_hotel_info
    },
    rooms_info() {
      return this.detail.check_data.rooms
    },
    employeeRate() {
      return JSON.parse(localStorage.employee_rate) || this.$store.state.employeeRate
    },
    checkRoomData() {
      let rooms = [];
      let pub = {
        HotelCode: this.hotel_info.hotel_code,
        Arrival: this.hotel_info.check_in_date,
        Departure: this.hotel_info.check_out_date,
        Adult: this.hotel_info.adults,
        Children: this.hotel_info.children
      };
      this.rooms_info.forEach((room) => {
        rooms.push(Object.assign({
          RateCode: room.rate_code,
          RoomTypeCode: room.roomtype_code
        }, pub))
      });
      return rooms
    },
    payData() {
      let data = {
        pay_type: this.form.pay_type,
        Arrival: this.hotel_info.check_in_date,
        Departure: this.hotel_info.check_out_date,
        Adults: this.hotel_info.adults,
        Children: this.hotel_info.children,
        Info: [],
        promotion_code: this.$route.query.promotion_code
      }
      this.form.rooms.forEach((room, index) => {
        let info = {}
        const codeInfo = {
          "Hotel_code": {
            "code": this.hotel_info.hotel_code,
            "name": this.hotel_info.hotel
          },
          "Roomtype_code": {
            "code": this.rooms_info[index].roomtype_code,
            "name": this.rooms_info[index].roomtype_name
          },
          "Rate_code": {
            "code": this.rooms_info[index].rate_code,
            "name": this.rooms_info[index].rate_name
          },
          "CountryCode": {
            "code": JSON.parse(room.CountryCode).code,
            "name": JSON.parse(room.CountryCode).name
          },
          "Title": {
            "code": JSON.parse(room.Title).code,
            "name": JSON.parse(room.Title).name
          },
          "Phone": room.area + "-" + room.Phone,
          packages: []
        }
        // this.rooms_info[index].package.forEach((x) => {
        //   codeInfo.packages.push({
        //     "BeginDate": this.detail.check_hotel_info.check_in_date,
        //     "EndDate": this.detail.check_hotel_info.check_out_date,
        //     code: x.package_code,
        //     name: x.package_name,
        //     price: x.total_price,
        //     Quantity: x.quantity,
        //   })
        // })

        Object.assign(info, room, codeInfo)
        data.Info.push(info)
      })
      return data
    },
    lang() {
      return this.$i18n.locale
    },
    gaWatcher() {
      const {dataLayerReady, detail} = this
      return {
        dataLayerReady,
        detail
      }
    },
    payTips() {
      let obj = {
        pay_type: '',
        pay_price: ''
      }
      const detail = this.detail.check_data;
      const grand = detail.grand_total
      const online = detail.online_payment
      const offline = detail.offline_payment
      if (!grand) {
        obj.pay_type = 'free-pay'
        obj.pay_price = 0
      } else if (grand === online) {
        obj.pay_type = 'full-pay'
        obj.pay_price = grand
      } else if (online) {
        obj.pay_type = 'guarantee-pay'
        obj.pay_price = online
      } else {
        obj.pay_type = 'no-pay'
        obj.pay_price = offline
      }
      obj.pay_price = `<span>${this.formatMoney(obj.pay_price, this.$t(this.currency))}</span>`
      return obj
    },
    isMobile() {
      return window.navigator.userAgent.toLowerCase().indexOf('mobile') > 0
    },
    autoInput() {
      const {formReady, account} = this
      return {
        formReady,
        account
      }
    },
  },
  watch: {
    gaWatcher(obj) {
      if (obj.dataLayerReady && obj.detail) {
        this.gaEvent(obj.detail)
      }
    },
    autoInput(obj) {
      if (obj.formReady && obj.account) {
        // 判断是否是员工房间
        this.form.rooms.forEach((room) => {
          if(room.rate_code == this.employeeRate[this.hotel_code]){
            room.Firstname = obj.account.first_name
            room.Lastname = obj.account.last_name
            room.Phone = +obj.account.phone
          }
        })
      }
    },
  }
}

</script>
